module.exports = __webpack_public_path__ + "140c4fbc273d7f58a9b5a5a9fa229234.png";